import Dialog, { DialogProps } from '../Dialog';
import Form from '../Form';

export interface EditDialogProps extends DialogProps {
  children?: React.ReactNode;
  disabled?: boolean;
  disableSubmitOnEnter?: boolean;
  onSubmit?: (values: any) => any;
  onReset?: () => void;
  onClose?: (arg: boolean) => void;
  fieldValue?: string;
}

const EditDialog = ({
  children,
  disabled,
  disableSubmitOnEnter,
  onSubmit,
  onReset,
  onClose,
  ...other
}: EditDialogProps) => {
  const handleClose = (c: any) => {
    if (onReset) {
      onReset();
    }

    if (onClose) {
      onClose(c);
    }
  };

  const handleSubmit = (values: any) => {
    if (onSubmit) {
      const errors = onSubmit(values);
      // redux-form's deferred submit thunk returns `false` (not undefined) for a
      // submit call it drops because one is already in flight — `if (errors)`
      // would read that as success. See ENG-5534 / WEBAPP-CC8.
      if (errors !== undefined) return;
    }

    if (onClose) {
      onClose(true);
    }
  };

  return (
    <Dialog {...other} onClose={handleClose} onCancel={handleClose} onConfirm={handleSubmit}>
      <Form
        onSubmit={handleSubmit}
        onReset={handleClose}
        disableSubmitOnEnter={disableSubmitOnEnter}
      >
        {children}
      </Form>
    </Dialog>
  );
};

export default EditDialog;
